import '~styles/light.scss';

import { Markdown } from '~components/Markdown';
import { ContentBlockWrapper } from '~containers/ArticlePage/ContentBlockWrapper/ContentBlockWrapper';

import styles from './ContentBlockText.module.scss';
import { ContentTextBlockProps } from './ContentBlockText.types';

export function ContentBlockText({
  text,
  ...sectionProps
}: ContentTextBlockProps) {
  return (
    <ContentBlockWrapper {...sectionProps}>
      <Markdown className={styles.text} markdownString={text} />
    </ContentBlockWrapper>
  );
}
